(function () {
    'use strict';
    var directiveParams = [
        'TransitionToHelper',
        transitionTo
    ];

    angular.module('aprima-core-ui').directive('transitionTo', directiveParams);
    angular.module('aprima-core-ui').directive('prmTransitionTo', directiveParams);

    function transitionTo(
        TransitionToHelper
    ) {
        return {
            restrict: 'A',
            link: link
        };
        
        function link(scope, element, attrs) {
            TransitionToHelper.registerTransitionTo(scope, element, attrs, getTransition);

            function getTransition() {
                var transition = scope.$eval(attrs.transitionTo || attrs.prmTransitionTo);

                if (angular.isFunction(transition)) {
                    transition = transition();
                }

                return transition;
            }
        }
    }
})();